module.exports = __webpack_public_path__ + "assets/img/1415.0cd6655a.png";